export enum Cookie {
  ADD_TO_HOME_SCREEN = 'A2HS',
  AFFILIATE_INFO = 'ptiram',
  AFFILIATE_REF = 'pstrk.afref',
  BIAB_CUSTOMER = 'BIAB_CUSTOMER',
  BIAB_LANGUAGE = 'BIAB_LANGUAGE',
  BIAB_TIMEZONE = 'BIAB_TZ',
  BRAND = 'BRAND',
  CLIENT_TIME_ZONE = 'CLIENT_TIME_ZONE',
  COOKIE_NOTIFICATION = 'cookieDisclaimer',
  COUNTRY = 'CTRY',
  CURRENCY = 'CURR',
  DOWNLOAD_BANNER = 'ADB',
  FACEBOOK_CLICK_ID = '_fbc',
  FACEBOOK_BROWSER_ID = '_fbp',
  FIRST_LOGIN = 'FIRST_LOGIN',
  INSTALL_ID = 'XIID',
  LANGUAGE = 'LANG',
  LICENSE = 'LCNS',
  LIMITED_MODE = 'LMTMOD',
  MAXYMISER_ID = 'pstrk.testid',
  MY_NEWS_SEEN = 'CRM_TARGETED_SEEN',
  NPS_INTERACTION = 'NPS_INTERACTION',
  ODDS_FORMAT = 'ODDS_FORMAT',
  ONE_TRUST_CONSENT = 'OptanonConsent',
  PROMO = 'promo',
  PROMO_IA = 'promo_ia',
  REDIRECT_CONTEXT = 'REDIRECT_CONTEXT',
  INSTITUTION_ID = 'institution_id',
  SIGNAL_ID = 'signalid',
  SIGNATURE = 'SBSG',
  SITE = 'SITE',
  SIZMEK_UID = 'sizmek_uid',
  SOFT_REDIRECT_CANCELLED = 'soft-redirect-cancelled',
  TOKEN = 'SBTK',
  USER = 'user',
  WEB_ID = 'WBID'
}
